import React from 'react';

const withRole =
  (allowedRoles: string[]) =>
  (Component: () => JSX.Element): JSX.Element | null => {
    return <Component />;
  };

export default withRole;
